import { Injectable } from '@angular/core';

import { TmsWebBaseImportService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class ImportProductDesignerService extends TmsWebBaseImportService {
  constructor() {
    super('ImportProductDesigner', 'Product Designers');
  }
}
